import { FaUser, FaUserCircle } from "react-icons/fa";
import { useTheme } from "../../context/useThemeContext";
import useAccountManagementStore from "../../stores/accountManagementStore";

export function ProfileIcon() {
    const { theme } = useTheme();

    const { userData } = useAccountManagementStore();

    function onClick(e: React.MouseEvent) {
        e.stopPropagation();
        useAccountManagementStore.getState().setLoginState("default");
    }

    return (
        <div className="rightContent mr-4 ml-3 z-20" onClick={onClick}>
            <div
                className="profileIcon relative rounded-full cursor-pointer overflow-hidden w-[28px] h-[28px] flex items-center justify-center"
                style={{
                    backgroundColor: "black",
                }}
            >
                {userData?.profilePicURL !== undefined ? (
                    <>
                        {/* Profile Picture */}
                        <div className="absolute bottom-0 left-0 right-0 top-0 overflow-hidden rounded-full">
                            {userData?.profilePicURL && (
                                <img
                                    alt="Profile Picture"
                                    className="h-full w-full object-cover object-top"
                                    referrerPolicy="no-referrer"
                                    src={`${
                                        userData?.profilePicURL
                                    }?t=${new Date().getTime()}`}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    <FaUser
                        size={16}
                        color={theme.fontColor[200]}
                        opacity={0.75}
                    />
                )}
            </div>
        </div>
    );
}
